import { render, staticRenderFns } from "./BotGenerateArticles.vue?vue&type=template&id=1576352e&"
import script from "./BotGenerateArticles.vue?vue&type=script&lang=js&"
export * from "./BotGenerateArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports